import { useContext } from 'react';

import EventContext from './EventContext';
import { Event } from '@legacy-types';

export function useEventWhenLoaded(): Event | null {
  return useContext(EventContext);
}